import {useIntl} from "react-intl";
import React, {useState} from "react";
import Selector from "../elements/Selector/Selector";
import Button from "../elements/Button/Button";
import Input from "../elements/Input/Input";
import ModalComp from "../ModalComp/ModalComp";

export default function Item(
    {
        key,
        item,
        setItem,
        disabledDelete,
        onDelete,
        vatsOptions

    }
) {
    const intl = useIntl()
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [label, setLabel] = useState(item.label)
    const [qty, setQty] = useState(item.qty)
    const [price, setPrice] = useState(item.price)
    const [priceIncludesVAT, setPriceIncludesVAT] = useState(item.price_includes_vat ?? false)
    const [vat, setVat] = useState(item.vat)
    const [vatName, setVatName] = useState(item.vat_name)
    const [vatPercent, setVatPercent] = useState(item.vat_percent)


    return (
            <tr key={key}>
                <td>{label}</td>
                <td className={"right-aligned-cell"}>{qty}</td>
                <td className={"right-aligned-cell"}>{parseFloat(price)}</td>
                <td className={"right-aligned-cell "}>
                    {vatsOptions.find(item => item.value === vat) ? vatsOptions.find(item => item.value === vat).label : 0}
                </td>
                <td className={"right-aligned-cell"}><strong>{parseFloat(qty * price).toFixed(2)}</strong></td>
                <td className={"right-aligned-cell delete"}>
                    <div className={"d-flex"}>
                        <Button
                            className={"btn-light btn-edit"}
                            tooltip={intl.formatMessage({id: 'general.edit'})}
                            icon={"fa-solid fa-pen"}
                            type={'button'}

                            onClick={() => setModalIsOpen(true)}
                        />
                        <Button
                            className={"btn-light btn-delete"}
                            tooltip={intl.formatMessage({id: 'general.delete'})}
                            icon={"fa-solid fa-trash"}
                            type={'button'}
                            disabled={disabledDelete}
                            onClick={() => onDelete()}
                        />
                    </div>
                </td>
                <ModalComp
                    title={intl.formatMessage({id: 'settings.company.sign_here'})}
                    isOpen={modalIsOpen}
                    onRequestClose={() => setModalIsOpen(false)}
                    className={"add-question-modal"}
                >

                        <div className={"content"} style={{maxHeight: "800px", height:'90%'}}>
                            <div className={"row"}>

                                <div className={"col-md-8  col-12"}>
                                    <div
                                        className={"form-label"}>{intl.formatMessage({id: 'general.title'})}</div>
                                    <Input
                                        className={"form-input"}
                                        type="text"
                                        style={{textAlign: "left", width: '90%', maxWidth: "unset", marginLeft: 0}}
                                        initValue={label}
                                        onChange={(value) => {
                                            setLabel(value)
                                        }}
                                    />
                                </div>
                                <div className={"col-md-4  col-12"}>
                                    <div
                                        className={"form-label"}>{intl.formatMessage({id: 'general.qty'})}</div>
                                    <div className={"form-control" + (qty ? '' : ' error')}>
                                        <input
                                            className={"d-flex form-input"}
                                            type="number"
                                            value={qty}
                                            step={1}
                                            onChange={(e) => setQty(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className={"col-12"}>
                                    <div className={""}>
                                        <div className={"float-right"}>
                                            <div
                                                className={"form-label"}>{intl.formatMessage({id: 'general.vat'})}</div>
                                            <Selector
                                                options={vatsOptions}
                                                value={vat}
                                                onChange={(option) => {
                                                    setVat(option.value)
                                                    setVatName(option.name)
                                                    setVatPercent(option.percent)
                                                }}
                                                isOptionDisabled={(option) => option.disabled}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={"col-12 mt-3"}>
                                    <div className={"form-control"}>
                                        <label className="form-switch d-flex align-items-center gap-2">
                                            <span>{intl.formatMessage({id: 'general.price_with_vat'})}</span>
                                        </label>
                                        <div className="d-flex mt-2" style={{minHeight: '38px'}}>
                                            <label className="d-flex align-items-center gap-1">
                                                <input
                                                    type="radio"
                                                    name="priceIncludesVAT"
                                                    className={"mt-0"}
                                                    checked={priceIncludesVAT === false}
                                                    onChange={() => setPriceIncludesVAT(false)}
                                                />
                                                {intl.formatMessage({id: 'general.no'})}
                                            </label>
                                            <label className="d-flex align-items-center ms-3">
                                                <input
                                                    type="radio"
                                                    className={"mt-0"}
                                                    name="priceIncludesVAT"
                                                    checked={priceIncludesVAT === true}
                                                    onChange={() => setPriceIncludesVAT(true)}
                                                />
                                                {intl.formatMessage({id: 'general.yes'})}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className={"col-md-6 col-12"}>
                                    <div className={"form-control" + (price ? '' : ' error')}>
                                        <div
                                            className={"form-label"}>{intl.formatMessage({id: 'general.price_without_vat'})}</div>
                                        <input
                                            className={"d-flex form-input"}
                                            type="number"
                                            disabled={priceIncludesVAT}

                                            value={priceIncludesVAT ? parseFloat(price / (1 + vatPercent / 100)).toFixed(2) : parseFloat(price)}
                                            step={0.01}
                                            onChange={(e) => setPrice(e.target.value)}
                                        /></div>
                                </div>

                                <div className={"col-md-6  col-12"}>
                                    <div className={"form-control" + (price ? '' : ' error')}>
                                        <div
                                            className={"form-label"}>{intl.formatMessage({id: 'general.price_plus_vat'})}</div>
                                        <input
                                            className={"d-flex form-input"}
                                            type="number"
                                            value={!priceIncludesVAT ?  parseFloat(price * (1 + vatPercent / 100)).toFixed(2) : parseFloat(price)}
                                            step={0.01}
                                            disabled={!priceIncludesVAT}
                                            onChange={(e) => setPrice(e.target.value)}
                                        /></div>
                                </div>
                            </div>
                        </div>
                        <div className={"footer"}>

                            <div className={"row"}>
                                <div className={"col-md-6 col-12 d-flex"}>
                                </div>
                                <div className={"col-md-6 col-12 d-flex"}>
                                    <Button
                                        className={"btn-primary mt-4 ms-auto"}
                                        value={intl.formatMessage({id: 'general.buttons.save'})}
                                        type={'button'}
                                        onClick={() => {
                                            if (qty && price) {
                                                setItem(label, qty,priceIncludesVAT, price, vat, vatName, vatPercent)
                                                setModalIsOpen(false)
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                </ModalComp>
            </tr>

    );
}

